import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EFilter, TListFilterState } from 'shared/common/types/filters';

const initialState: TListFilterState = { filterId: EFilter.Cost, asc: true };

const listFiltersSlice = createSlice({
  initialState,
  name: 'listFilters',
  reducers: {
    setFilter: (state, action: PayloadAction<TListFilterState>) => {
      state.filterId = action.payload.filterId;
      state.asc = action.payload.asc;
    },
  },
});

export const {
  reducer: listFiltersReducer,
  actions: { setFilter },
} = listFiltersSlice;
